import { VenueOutput } from 'js/model/rainbow/venue/VenueOutput';

export const getPageDataTrackingProps = (venue: VenueOutput) => {
  const { rating, images, employees, menu, type, reviews } = venue;

  const portfolioImageCount = employees.reduce(
    (sum, employee) => sum + employee.portfolioImages.length,
    0
  );
  const treatments = menu.menuGroups.reduce(
    (sum, group) => sum + group.menuItems.length,
    0
  );

  return {
    screen_review_number: reviews?.length,
    screen_review_score: rating.average,
    screen_venue_photo_number: images.length,
    screen_has_portfolio: portfolioImageCount > 0,
    screen_portfolio_photo_number: portfolioImageCount,
    screen_treatment_category_number: treatments,
    screen_treatment_number: menu.treatmentCategoryGroups?.length,
    screen_venue_type: type?.normalisedName,
  };
};
